import {
    RetrieveAccount,
    InsuredBasicInfo,
    YourInformation,
    QuoteSuccess
} from '../../SharedComponents';
import ClientPreferences from './ClientPreferences';
import CaseInitiation from './CaseInitiation';

export {
    CaseInitiation,
    InsuredBasicInfo,
    RetrieveAccount,
    YourInformation,
    ClientPreferences,
    QuoteSuccess,
}


// WEBPACK FOOTER //
// ./src/components/Product/PermLifeInsurance/steps/index.js